var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockScreenRotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "m 14.5,16.5 h -8 C 6.224,16.5 6,16.276 6,16 V 10 C 6,9.724 6.224,9.5 6.5,9.5 h 8 c 0.276,0 0.5,0.224 0.5,0.5 v 6 c 0,0.276 -0.224,0.5 -0.5,0.5 z M 7,15.5 h 7 v -5 H 7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M 10.5,14.5 C 10.224,14.5 10,14.276 10,14 v -1.5 c 0,-0.276 0.224,-0.5 0.5,-0.5 0.276,0 0.5,0.224 0.5,0.5 V 14 c 0,0.276 -0.224,0.5 -0.5,0.5 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "currentColor"
    },
    cx: 10.5,
    cy: 12.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M 13.5,10.5 C 13.224,10.5 13,10.276 13,10 V 9 C 13,7.622 11.879,6.5 10.5,6.5 9.121,6.5 8,7.622 8,9 v 1 C 8,10.276 7.776,10.5 7.5,10.5 7.224,10.5 7,10.276 7,10 V 9 C 7,7.07 8.57,5.5 10.5,5.5 12.43,5.5 14,7.07 14,9 v 1 c 0,0.276 -0.224,0.5 -0.5,0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M 10.5,21.5 C 4.71,21.5 0,16.79 0,11 0,5.21 4.71,0.5 10.5,0.5 16.29,0.5 21,5.21 21,11 21,11.276 20.776,11.5 20.5,11.5 20.224,11.5 20,11.276 20,11 20,5.762 15.738,1.5 10.5,1.5 5.262,1.5 1,5.762 1,11 c 0,5.238 4.262,9.5 9.5,9.5 2.502,0 4.864,-0.964 6.651,-2.716 0.196,-0.194 0.513,-0.189 0.707,0.007 0.193,0.197 0.189,0.514 -0.008,0.707 -1.974,1.936 -4.585,3.002 -7.35,3.002 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "m 20.5,12.5 c -0.128,0 -0.256,-0.049 -0.354,-0.146 l -3,-3 c -0.195,-0.195 -0.195,-0.512 0,-0.707 0.195,-0.195 0.512,-0.195 0.707,0 l 2.646,2.646 2.646,-2.646 c 0.195,-0.195 0.512,-0.195 0.707,0 0.195,0.195 0.195,0.512 0,0.707 l -3,3 C 20.756,12.451 20.628,12.5 20.5,12.5 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockScreenRotation);
export default __webpack_public_path__ + "static/media/lock-screen-rotation.32dd7cb1.svg";
export { ForwardRef as ReactComponent };